import { LanguageIcon } from "@heroicons/react/24/outline";
import { SupportedLanguage } from "@onetutor/shared/type";
import { useTranslation } from "react-i18next";
import { IconWithTooltip } from "../IconWithTooltip";

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const { t } = useTranslation("header");

  const handleLanguageChange = () => {
    if (i18n.language === SupportedLanguage.DE) {
      i18n.changeLanguage(SupportedLanguage.EN);
    } else if (i18n.language === SupportedLanguage.EN) {
      i18n.changeLanguage(SupportedLanguage.DE);
    }
  };

  return (
    <IconWithTooltip
      icon={<LanguageIcon className="h-5 w-5" />}
      tooltip={t("switchLanguageLabel")}
      handler={handleLanguageChange}
      className="btn btn-ghost btn-sm btn-circle"
      tooltipPosition="bottom"
    />
  );
}
